import React from 'react';
import { FormattedNumber } from 'react-intl';

import CustomMaskedInput from 'components/MaskedOutput/index';

interface IProps {
  value: any;
  format?: string;
  disableSymbol?: boolean;
}

const ColoredFormattedNumber: React.FC<IProps> = ({ value, format, disableSymbol }) => {
  const fmt = format || 'BRL';

  return (
    <span className={value >= 0 ? 'text-success' : 'text-error'}>
      {disableSymbol ? (
        <CustomMaskedInput mask='money' value={value} />
      ) : (
        <FormattedNumber value={value} format={fmt} />
      )}
    </span>
  );
};

export default ColoredFormattedNumber;
